import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function ArrowUpRightIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M7.707 17.707a1 1 0 1 1-1.414-1.414L14.586 8H7a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V9.414z" />
    </Icon>
  );
}

ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
